<app-view *ngIf="item && item?.view && item?.view?.data" [items]="item?.view?.data?.content" [info]="item?.view" [data]="data_data"></app-view>
